/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, HostBinding, Input, OnInit } from "@angular/core";

@Component({
  selector: "bci-burger",
  templateUrl: "./bci-burger.component.html",
  styleUrls: ["./bci-burger.component.scss"],
  standalone: false
})
export class BciBurgerComponent {
  @HostBinding("class.burger") true;

  @Input()
  open = false;
}
